import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxLoadPanelComponent,
  DxPopupComponent,
} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import {
  TIPI_PROPRIETA_ARTICOLO_LIST,
  TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO,
  TIPO_PROPRIETA_ARTICOLO_DATA,
  TIPO_PROPRIETA_ARTICOLO_NUMERO,
  TIPO_PROPRIETA_ARTICOLO_SELMULTI,
} from 'src/app/consts/tipi-proprieta-articolo';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { Articoli } from 'src/app/models/articoli';
import CustomStore from 'devextreme/data/custom_store';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-popup-gestione-articoli-matricola',
  templateUrl: './popup-gestione-articoli-matricola.component.html',
  styleUrls: ['./popup-gestione-articoli-matricola.component.scss'],
  imports: [
    DxPopupComponent,
    DxLoadPanelComponent,
    DxButtonComponent,
    DxDataGridComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoLookupComponent,
    DxiColumnComponent,
  ],
  standalone: true,
})
export class PopupGestioneArticoliMatricolaComponent implements OnInit {
  private tipiArticoliService = inject(TipiArticoliService);
  private articoliMatricolaService = inject(ArticoliMatricolaService);

  @ViewChild('dataGridArticoliMatricola', { static: false })
    dataGridArticoliMatricola: DxDataGridComponent;
  @Output() popupGestioneArticoliMatricolaEventEmitter =
    new EventEmitter<boolean>();
  @Input() articolo: Articoli;

  readonly listTipiProps = TIPI_PROPRIETA_ARTICOLO_LIST;
  readonly TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO =
    TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO;
  readonly TIPO_PROPRIETA_ARTICOLO_NUMERO = TIPO_PROPRIETA_ARTICOLO_NUMERO;
  readonly TIPO_PROPRIETA_ARTICOLO_DATA = TIPO_PROPRIETA_ARTICOLO_DATA;
  readonly TIPO_PROPRIETA_ARTICOLO_SELMULTI = TIPO_PROPRIETA_ARTICOLO_SELMULTI;

  loadPanelVisible = false;

  tipoArticolo: TipiArticoli;
  listPropsArtMatricola: any[];
  dataSource: any;

  constructor() {
    this.onSalvaClick = this.onSalvaClick.bind(this);
  }

  ngOnInit() {
    this.loadTipologia();
    this.loadDataSource();
  }

  loadTipologia() {
    this.tipiArticoliService.get(this.articolo?.idTipo).subscribe({
      next: (res) => {
        this.tipoArticolo = res;
        this.listPropsArtMatricola = JSON.parse(res.propJSON);
      },
      error: (error) => {
        if (error?.error?.text) {
          const errT = error?.error?.text();
          const errj = JSON.parse(errT);
          notify(errj?.title, 'warning', 3000);
        } else {
          notify('Errore caricamento tipologia', 'error', 3000);
        }
      },
    });
  }

  onRowUpdating(e) {
    const updatedProps = Object.assign(e.oldData.props, e.newData.props);
    e.newData = Object.assign(e.oldData, e.newData);
    e.newData.props = updatedProps;
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(
          this.articoliMatricolaService.list(this.articolo.id),
        )
          .then((response) => {
            return {
              data: response.map((item) => {
                let newItem: any;
                newItem = item;
                newItem.props = new Object();
                const proprieta = JSON.parse(item.propJson);
                this.listPropsArtMatricola?.forEach((element) => {
                  const prop = proprieta.find((p) => p.nome == element.nome);
                  newItem.props[element.nome] = prop?.valore;
                });
                return newItem;
              }),
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      update: (key, values) => {
        values.propJson = this.reconvertDataMapped(
          values.propJson,
          values.props,
          this.listPropsArtMatricola,
        );
        return firstValueFrom(this.articoliMatricolaService.update(key, values))
          .then(() => {
            console.log('articolo matricola updated');
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.articoliMatricolaService.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
    });
  }

  reconvertDataMapped(origJsonStr, currentProps, propsTipo) {
    const origData = JSON.parse(origJsonStr);
    propsTipo?.forEach((element) => {
      if (origData.find((p) => p.nome == element.nome)) {
        origData.find((p) => p.nome == element.nome).valore =
          currentProps[element.nome];
      } else {
        const newData = {
          nome: element.nome,
          tipo: element.tipo,
          obbligatorio: element.obbligatorio,
          controlloNotifica: element.controlloNotifica,
          selMultiplaDati: element.selMultiplaDati,
          valore: currentProps[element.nome],
        };
        origData.push(newData);
      }
    });
    return JSON.stringify(origData);
  }

  getDataType(tipo) {
    if (tipo == TIPO_PROPRIETA_ARTICOLO_NUMERO) {
      return 'number';
    } else if (tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
      return 'date';
    }
    return 'string';
  }

  getDataFormat(tipo) {
    if (tipo == TIPO_PROPRIETA_ARTICOLO_NUMERO) {
      return '0';
    } else if (tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
      return 'dd/MM/yyyy';
    }
    return '';
  }

  onEsciClick() {
    this.popupGestioneArticoliMatricolaEventEmitter.emit(null);
  }

  onSalvaClick() {
    this.dataGridArticoliMatricola.instance
      .saveEditData()
      .then(() => {
        notify('Dati articoli matricola salvati.', 'success', 3000);
        this.popupGestioneArticoliMatricolaEventEmitter.emit(true);
      })
      .catch(() =>
        notify('Si sono verificati errori nel salvataggio.', 'warning', 3000),
      );
  }
}
